import styled from 'styled-components';
import { ViewVehicleProvider } from '../../context/ViewVehicleContext';
import { SectionLayout } from './components/SectionLayout';
import { ViewVehicleSectionsHeader } from './components/Header';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  @media (max-width: 1024px) {
    margin-top: 32px;
  }
`;

type Props = {
  forceMobileLayout?: boolean;
  twoColumnLayout?: boolean;
  publicView?: boolean;
};

export const VehicleSections = ({ forceMobileLayout, twoColumnLayout, publicView }: Props) => {
  return (
    <ViewVehicleProvider publicView={publicView}>
      <Wrapper>
        <ViewVehicleSectionsHeader />
        <SectionLayout forceMobileLayout={forceMobileLayout} twoColumnLayout={twoColumnLayout} />
      </Wrapper>
    </ViewVehicleProvider>
  );
};
